var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-color-main",
    d: "M12.646,130.3,7.114,147.058H0L18.1,93.8h8.3l18.175,53.263H37.222L31.531,130.3Zm17.466-5.374L24.9,109.6c-1.189-3.476-1.976-6.635-2.767-9.718h-.158c-.791,3.16-1.659,6.4-2.689,9.641l-5.216,15.409Zm39.968-1.221-7.708,23.35H52.458L77.681,72.822H89.246l25.333,74.236H104.337l-7.931-23.35Zm24.343-7.491L87.154,94.849C85.5,90,84.4,85.6,83.3,81.3h-.22c-1.1,4.4-2.313,8.921-3.747,13.437l-7.27,21.478Zm49.962,1.658-9.637,29.183H122.359l31.524-92.783h14.455L200,147.058H187.2l-9.911-29.183Zm30.422-9.362-9.086-26.706c-2.063-6.058-3.441-11.563-4.817-16.932h-.276c-1.376,5.507-2.89,11.149-4.68,16.794l-9.086,26.844Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSize);
export default __webpack_public_path__ + "static/media/font-size.c6f624b3b8ad00366587a7ad9883769e.svg";
export { ForwardRef as ReactComponent };